import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let PageLoading = class PageLoading extends Vue {
    mounted() {
        this.loadingToggle();
    }
    watchLoading() {
        this.loadingToggle();
    }
    loadingToggle() {
        const pageLoading = this.$refs.pageLoading;
        if (pageLoading.parentElement) {
            pageLoading.parentElement.classList.toggle('page-loading-wrap', this.value);
        }
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], PageLoading.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], PageLoading.prototype, "shade", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], PageLoading.prototype, "loadingText", void 0);
tslib_1.__decorate([
    Prop({ default: '#FFFFFF' })
], PageLoading.prototype, "shadeColor", void 0);
tslib_1.__decorate([
    Prop({ default: 0.85 })
], PageLoading.prototype, "shadeOpacity", void 0);
tslib_1.__decorate([
    Watch('value')
], PageLoading.prototype, "watchLoading", null);
PageLoading = tslib_1.__decorate([
    Component({
        name: 'page-loading'
    })
], PageLoading);
export default PageLoading;
